module.exports = __webpack_public_path__ + "static/user_details-2ca90d3abbd3efa02ffc62c146feb7b0.png";